// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609151113/js/" + chunkId + "." + {"44":"a1680437","225":"0ec4951c","481":"1232972a","486":"db726936","770":"0975b86b"}[chunkId] + ".0.5072407857970521.chunk.js";
};